import { useParams } from 'react-router-dom'

import EditMedicalLeaveUpdate from 'modules/timeoff/components/EditMedicalLeaveUpdate'

import { useOnClose } from './useOnClose'

const EditMedicalLeaveUpdatePage = () => {
  const { id, leave_update_id: leaveUpdateId } = useParams()
  const onClose = useOnClose(id)

  if (leaveUpdateId === undefined) {
    return null
  }

  return <EditMedicalLeaveUpdate leaveUpdateId={+leaveUpdateId} onClose={onClose} />
}

export default EditMedicalLeaveUpdatePage
